(() => {
  "use strict";

  const COOKIE_FALLBACK_NAME = "mr_age_verified";
  const ACTIVE_CLASS = "mr-age-gate-active";

  const getCookie = (name) => {
    const encodedName = encodeURIComponent(name) + "=";
    const cookies = document.cookie.split(";");

    for (const cookie of cookies) {
      const trimmed = cookie.trim();

      if (trimmed.startsWith(encodedName)) {
        return decodeURIComponent(
          trimmed.substring(encodedName.length)
        );
      }
    }

    return null;
  };

  const setCookie = (name, value, days) => {
    const seconds = Math.max(1, days) * 24 * 60 * 60;
    const secure = window.location.protocol === "https:"
      ? "; Secure"
      : "";

    document.cookie = [
      `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
      `Max-Age=${seconds}`,
      "Path=/",
      "SameSite=Lax",
      secure,
    ].join("; ");
  };

  const initAgeGate = () => {
    const gate = document.querySelector("[data-age-gate]");

    if (!gate) {
      document.documentElement.classList.remove(ACTIVE_CLASS);
      return;
    }

    const cookieName =
      gate.dataset.cookieName || COOKIE_FALLBACK_NAME;

    const durationDays =
      Number.parseInt(gate.dataset.durationDays || "365", 10);

    const enterButton = gate.querySelector(
      "[data-age-gate-enter]"
    );

    const focusableSelector = [
      "button:not([disabled])",
      "a[href]",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      '[tabindex]:not([tabindex="-1"])',
    ].join(",");

    let previouslyFocusedElement = null;

    const isVerified = () => getCookie(cookieName) === "1";

    const showGate = () => {
      previouslyFocusedElement = document.activeElement;

      gate.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add(ACTIVE_CLASS);

      window.requestAnimationFrame(() => {
        enterButton?.focus();
      });
    };

    const hideGate = () => {
      gate.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove(ACTIVE_CLASS);

      if (
        previouslyFocusedElement &&
        typeof previouslyFocusedElement.focus === "function"
      ) {
        previouslyFocusedElement.focus();
      }
    };

    const verifyAge = () => {
      setCookie(cookieName, "1", durationDays);
      hideGate();

      document.dispatchEvent(
        new CustomEvent("mr:age-verified")
      );
    };

    const trapFocus = (event) => {
      if (
        event.key !== "Tab" ||
        gate.getAttribute("aria-hidden") !== "false"
      ) {
        return;
      }

      const focusable = Array.from(
        gate.querySelectorAll(focusableSelector)
      ).filter((element) => {
        return element.offsetParent !== null;
      });

      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    };

    enterButton?.addEventListener("click", verifyAge);
    gate.addEventListener("keydown", trapFocus);

    if (isVerified()) {
      hideGate();
    } else {
      showGate();
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initAgeGate,
      { once: true }
    );
  } else {
    initAgeGate();
  }

  document.addEventListener(
    "shopify:section:load",
    initAgeGate
  );
})();
